module.exports = __webpack_public_path__ + "img/2.5d_6.461bc0ae.jpg";